import { useEffect } from 'react';
import { connect } from 'react-redux';
import { msg } from '@gonfalon/messages/msg';
import { ProgressBar } from '@launchpad-ui/components';

import { fetchAccount as fetchAccountAction } from '#actions/account';
import { accountSelector } from '#reducers/account';
import { subscriptionSelector } from '#reducers/billing';
import { profileSelector } from '#reducers/profile';
import type { GlobalState } from '#reducers/state';
import { ready } from '#utils/reduxUtils';

import { UpsellFeature, type UpsellFeatureProps } from './UpsellFeature';

export type UpsellFeatureContainerProps = UpsellFeatureProps & { fetchAccount(): void; isReady: boolean };

const BaseUpsellFeatureContainer = ({ fetchAccount, isReady, ...finalProps }: UpsellFeatureContainerProps) => {
  useEffect(() => {
    if (!isReady) {
      fetchAccount();
    }
  }, []);
  if (!isReady) {
    return (
      <div data-test-id="UpsellFeatureContainer-progress">
        <ProgressBar aria-label={msg('billing.status.loading')} isIndeterminate />
      </div>
    );
  }
  return <UpsellFeature {...finalProps} />;
};

const mapStateToProps = (state: GlobalState) => {
  const profile = profileSelector(state).get('entity');
  const account = accountSelector(state);
  const accountEntity = account?.get('entity');
  const checkAccess = accountEntity?.checkAccess({ profile });
  const updateSubscriptionAccess = checkAccess && checkAccess('updateSubscription');
  const subscription = subscriptionSelector(state);
  const enterpriseCampaignActive = !!subscription.entity.getEnterpriseCampaign()?.isActive();

  return {
    isReady: ready(account),
    canManagePlans: updateSubscriptionAccess?.isAllowed || false,
    account: accountEntity,
    enterpriseCampaignActive,
  };
};

const mapDispatchToProps = {
  fetchAccount: fetchAccountAction,
};

export { BaseUpsellFeatureContainer as UpsellFeatureContainerBase };
export const UpsellFeatureContainer = connect(mapStateToProps, mapDispatchToProps)(BaseUpsellFeatureContainer);
